'use es6';

import { SHARED_DND_UPDATE_CONTEXT_MONITOR } from 'DesignData/actions/ActionTypes';
/**
 * Relays data from the SharedDragDropContext's monitors.
 */

export function updateDragDropContextMonitor(isDragging, itemType, item) {
  return {
    type: SHARED_DND_UPDATE_CONTEXT_MONITOR,
    isDragging,
    itemType,
    item
  };
}